import React from 'react';
import { useAdminStore } from '../../stores/useAdminStore';
import { BaseInlineActions } from './BaseInlineActions';
import { PhotosByEvent } from '../../types';
import './InlineEventActions.css';

interface InlineEventActionsProps {
  eventData: PhotosByEvent[string];
}

export const InlineEventActions: React.FC<InlineEventActionsProps> = ({
  eventData
}) => {
  const openEventActionsModal = useAdminStore(s => s.openEventActionsModal);

  const handleGearClick = () => {
    openEventActionsModal(eventData.event);
  };

  return (
    <BaseInlineActions
      title="Event actions"
      ariaLabel="Open event actions menu"
      onClick={handleGearClick}
      className="inline-event-actions"
      data-testid="event-actions-gear"
    >
      ⚙️
    </BaseInlineActions>
  );
};
